import { render, staticRenderFns } from "./Solution.vue?vue&type=template&id=2d69fc53&scoped=true&"
import script from "./Solution.vue?vue&type=script&lang=js&"
export * from "./Solution.vue?vue&type=script&lang=js&"
import style0 from "./Solution.vue?vue&type=style&index=0&id=2d69fc53&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d69fc53",
  null
  
)

export default component.exports